module.exports = __webpack_public_path__ + "static/media/Best-Google-Advertising-Agency-Canada.cf9555c6.png";